import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
    Sentry.captureMessage(`Page Not Found (404): ${location.pathname}`, {
      level: 'warning',
      tags: {
        path: location.pathname,
        error_type: '404',
      },
    });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t('oops_page_not_found')}</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          {t('return_to_home')}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
